import script from "./mealsList.vue?vue&type=script&setup=true&lang=js"
export * from "./mealsList.vue?vue&type=script&setup=true&lang=js"

import "./mealsList.vue?vue&type=style&index=0&id=c83a006e&lang=scss&scoped=true"

import exportComponent from "D:\\workFolder\\payment-H5\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c83a006e"]])

export default __exports__